import { callApi, REFRESH_STATE } from "@/services/api"
import { io, Socket } from "socket.io-client"
import type { App } from "vue"

// const getAuthUser = async () => {
//   if (localStorage.getItem("access_token")) {
//     console.log("Access token found, fetching auth user")
//     try {
//       const {
//         data: { data: userInfo },
//       } = await callApi.getUserInfo()
//       store.dispatch("auth/setUser", userInfo)
//       return userInfo
//     } catch (error) {
//       console.error("Failed to fetch user info:", error)
//     }
//   } else {
//     console.log("No access token found for fetching auth user")
//   }
// }

const access_token = localStorage.getItem("access_token")
console.log("Initial auth user fetched for socket")
console.log("Access token:", access_token)
// Создаём сокеты после того, как токен точно в store
const privateSocket: Socket = io(`${process.env.VUE_APP_API_URL}/private`, {
  autoConnect: true,
  path: "/socket.io",
  auth: {
    token: access_token,
  },
})

const publicSocket: Socket = io(`${process.env.VUE_APP_API_URL}/public`, {
  autoConnect: true,
  path: "/socket.io",
})
// const privateSocket: Socket = io(
//   `${process.env.VUE_APP_API_URL}:5300/private`,
//   {
//     autoConnect: true,
//     auth: {
//       token: access_token,
//     },
//   }
// )

// const publicSocket: Socket = io(`${process.env.VUE_APP_API_URL}:5300/public`, {
//   autoConnect: true,
// })

publicSocket.on("connect", () => {
  console.log("🔌 publicSocket Connected")
})
privateSocket.on("connect", () => {
  console.log("🔌 privateSocket Connected")
})

privateSocket.on("connect_error", async (err) => {
  if (err.message === "Invalid token") {
    if (!REFRESH_STATE.refreshing) {
      REFRESH_STATE.promise = callApi.refreshToken()
    }

    const accessToken = await REFRESH_STATE.promise
    if (accessToken) {
      privateSocket.auth = { token: accessToken }
      privateSocket.connect()
      console.log("🔌 privateSocket Reconnected with new token")
    } else {
      console.error("🔌 privateSocket Failed to get new token")
    }
  } else {
    console.error("🔌 privateSocket Connection Error:", err.message)
    console.log(err.message.toString())
  }
})
publicSocket.on("disconnect", (reason) => {
  console.log("🔌 publicSocket Disconnected:", reason)
})
privateSocket.on("disconnect", (reason) => {
  console.log("🔌 privateSocket Disconnected:", reason)
})

export default {
  install: (app: App) => {
    // store.commit("auth/SET_FETCHING_PROFILE", getAuthUser())
    // const promise = getAuthUser()

    // store.commit("auth/SET_FETCHING_PROFILE", promise) // сохраняем промис в Vuex

    // await promise // ждём, пока пользователь загрузится

    // Делаем сокеты доступными глобально
    app.config.globalProperties.$privateSocket = privateSocket
    app.config.globalProperties.$publicSocket = publicSocket
  },
}

export { privateSocket, publicSocket }
